module.exports = __webpack_public_path__ + "img/laos.027bfe9e.png";